import { Availability } from '../../../lib/PlannerDTOs';
import { State } from '../../../store/state';
import { expAvailabilityEntitiesSelector } from '../../../store/state/entities/selectors';

export const expAvailabilitySelector = (
  state: State,
  domain: string,
  restrictBy: string,
): Availability | null | undefined => {
  const key = `${domain}--${restrictBy}`;
  const expAvailabilityEntities = expAvailabilityEntitiesSelector(state);
  const expAvailability = expAvailabilityEntities
    ? expAvailabilityEntities[key]
    : null;
  const availability = expAvailability ? expAvailability.availability : null;
  return availability;
};

export const expAvailabilityLoadingStateSelector = (
  state: State,
  domain: string,
  restrictBy: string,
): boolean => {
  if (state.availability === undefined) {
    return false;
  }
  const key = `${domain}--${restrictBy}`;
  const availability = state.availability[key];
  const isFetching = availability ? availability.isFetching : false;
  return isFetching;
};
